import React       from 'react';
import ReactDom    from 'react-dom';
import Moment      from 'moment';

import Const       from 'fw_const';
import Utils       from 'utils';
import Sanitize    from '@utils/sanitize';
import SubLoading  from 'sub_loading';
import Sortable    from 'react-sortablejs';
import DropDown    from 'dropdown';

import ContentsModal  from '@partials/contents-modal';
import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';

// -------------------------------------------------------


const progressList = ['assign_complete','draft','waiting_post','insight_check','claim','complete'];

class Calender extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
    
    this.update = {};
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      sort       : 'register_date',
      sort_order : 'desc',
      is_loading : false,
      updateData : {},
      modal      : false,
    };
  }
  // -------------------------------------------------------
  
  toggleModal(flg) {
    this.setState({ modal: flg });
  }
  // -------------------------------------------------------
  
  /*
   * モード変更
   */
  changeSort(sort) {
    let order = (this.state.sort == sort && this.state.sort_order == 'desc' ) ? 'asc' : 'desc';
    this.setState({ sort: sort, sort_order: order, is_loading: true });
    
    setTimeout( function(){
      this.setState({ is_loading: false });
    }.bind(this), 50);
  }
  // -------------------------------------------------------
  
  /*
   * モード変更
   */
  updateEvent(insta_user_id, column) {
    let update = {
      project_id    : this.props.data.project.id,
      insta_user_id : insta_user_id,
      column        : column.replace('option_', ''),
      value         : this.update[insta_user_id][column].value
    };
    
    Utils.request.bind(this)('/api/project/workflow/update_workflow_option', update,
      function(res){
        let updateData = this.state.updateData;
        if( updateData[insta_user_id] == undefined ) updateData[insta_user_id] = {};
        updateData[insta_user_id][update.column] = update.value;
        this.setState({ updateData: updateData });
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  render() {
    let data     = this.props.data;
    let userData = data.userData || {};
    //console.log(data);

    let columns = [
      { id: 'full_name',              name: 'インフルエンサー名',    value: 'direct',  fmt: 'full_name'  },
      { id: 'insta_id',               name: 'InstagramID',           value: 'direct',  fmt: 'str' },
      { id: 'followers',              name: 'フォロワー数',          value: 'direct',  fmt: 'num'  },
      { id: 'option_status',          name: 'ステータス',            value: 'option',  fmt: 'form' },
      { id: 'option_recommend_text',  name: '起用トライブ',          value: 'option',  fmt: 'str' },
      { id: 'option_draft',           name: '下書き',                value: 'option',  fmt: 'draft' },
      
    ];
    
    let project_option = [];
    let sort_option = [];
    let my_show_list = [];
    let hidden_list = [];
    
    try {
      let obj = JSON.parse(data.project.detail.custom_casting_columns);
      //console.log(obj);
      project_option = obj.originalList;
      sort_option = obj.sortList;
      my_show_list = obj.myShowList;
      hidden_list = obj.hiddenList;
    } catch(e) {}
    
    // カラム編集
    my_show_list.map((id) => {
      columns = columns.map((d) => {
        if( id == d.id ) d.view = 'my';
        return d;
      });
    });
    hidden_list.map((id) => {
      columns = columns.map((d) => {
        if( id == d.id ) d.view = 'hidden';
        return d;
      });
    });
    
    // カラム追加/削除
    project_option.map((d) => { columns.push(d); });
    if( userData.is_guest == 1 ){
      columns = columns.filter((d) => { if( my_show_list.indexOf(d.id) == -1 ) return d; });
    }
    
    // カラムソーティング
    columns = columns.map((d) => {
      d.order_no = 99;
      if( sort_option.indexOf(d.id) >= 0 ) d.order_no = sort_option.indexOf(d.id);
      return d;
    });
    columns = Utils.sort(columns, 'order_no', 'asc');
    
    // 編集用データ
    let editColumns = columns.concat();
    
    // 非表示
    columns = columns.filter((d) => { if( hidden_list.indexOf(d.id) == -1 ) return d; });
    
    let influencers_result = [];
    if( this.state.is_loading == false ){
      let influencers = [];
      
      let list = Utils.createObjectToArray((data.workflow || {}).influencers || {});
      list.map((d) => {
        
        columns.map((c) => {
          if( d[c.id] == undefined ) d[c.id] = '';
        });
        
        try {
          for( let i in this.state.updateData[d.insta_user_id] ){
            d['option_'+ i] = this.state.updateData[d.insta_user_id][i];
          }
        } catch(e) {}
        
        try {
          d.option_recommend_text = d.status.recommend_text
        } catch(e) {}
        
        try {
          try {
            let json = JSON.parse(d.status.workflow_option);
            for( let i in json ) d['option_'+ i] = json[i];
          } catch(e) {}
          
          if( d.status.is_assign == 1 ){
            influencers.push(d);
          } else if( progressList.indexOf(d.progress) >= 0 ){
            influencers.push(d);
          }
        } catch(e) {}
        
      });
      
      influencers_result = Utils.sort(influencers.concat(), this.state.sort, this.state.sort_order);
      //console.log(influencers_result);
      
    }
    //console.log(influencers);
    //console.log(this.state.updateData);
    
    let projectWidth = (200 * columns.length);
    
    console.log(influencers_result);
    
    return (
      <div className="project-casting-list">
        <div className="casting-list-contents">
          
          {( userData.is_guest != 1 ) &&
            <div className="casting-list-menus">
              <p className="edit-column" onClick={this.toggleModal.bind(this, true)}>カラムを編集</p>
            </div>
          }
          
          <ul className="projects-list-ul" style={{ width: projectWidth }}>
            
            <li className="projects-header">
              <div className="score-box">
                { columns.map((d, key) => {
                  let item = (
                    <div className={'projects-score '+ d.id} key={key} onClick={this.changeSort.bind(this, d.id)}>
                      <p>
                        {d.name}
                        { (d.edit == 'all') &&
                          <OverlayTrigger key={key} placement="top" delayShow={250} overlay={<Tooltip>相互編集が可能です</Tooltip>}>
                            <i className="material-icons">repeat</i>
                          </OverlayTrigger>
                        }
                      </p>
                      <div className="sort">
                        { (this.state.sort == d.id && this.state.sort_order == 'asc' ) ? <i className="material-icons on">keyboard_arrow_up</i> : <i className="material-icons off">keyboard_arrow_up</i> }
                        { (this.state.sort == d.id && this.state.sort_order == 'desc' ) ? <i className="material-icons on">keyboard_arrow_down</i> : <i className="material-icons off">keyboard_arrow_down</i> }
                      </div>
                    </div>
                  );
                  
                  if( d.help != undefined ){
                    return <OverlayTrigger key={key} placement="top" delayShow={250} overlay={<Tooltip>{d.help}</Tooltip>}>{item}</OverlayTrigger>
                  } else {
                    return item;
                  }
                })}
              </div>
            </li>
            
            { influencers_result.map((d, key) => {
              return (
                <li key={key}>
                  <div className="score-box score-body">
                    { columns.map((c, key) => {
                      let val = '-';
                      
                      if( c.value == 'direct' ){
                        val = ( d[c.id] == undefined ) ? '-' : d[c.id];
                      }
                      if( c.value == 'option' ){
                        val = ( d[c.id] == undefined ) ? '' : d[c.id];
                      }
                      if( c.is_original == true ){
                        val = ( d[c.id] == undefined ) ? '' : d[c.id];
                      }
                      
                      if( c.fmt == 'form' || c.is_original == true ){
                        if( this.update[d.insta_user_id] == undefined ) this.update[d.insta_user_id] = {};
                        if( this.update[d.insta_user_id][c.id] == undefined ) this.update[d.insta_user_id][c.id] = {};
                        
                        if( userData.is_guest == 1 && c.edit != 'all' ){
                          let caption = null;
                          try { if( val != undefined && val != null ) caption = Sanitize.nl2br(val); } catch(e) {}
                          
                          return (
                            <div className={'projects-score '+ c.id} key={key}>
                              <div className="caption" dangerouslySetInnerHTML={{ __html: caption }} />
                            </div>
                          );
                        } else {
                          return (
                            <div className={'projects-score '+ c.id} key={key}>
                              <textarea className="text" ref={(input) => { this.update[d.insta_user_id][c.id] = input }} onBlur={this.updateEvent.bind(this, d.insta_user_id, c.id)} placeholder={''} defaultValue={val} />
                            </div>
                          );
                        }
                        
                      }
                      if( c.fmt == 'draft' ){
                        try {
                          return (
                            <div className={'projects-score '+ c.id} key={key}>
                              <ul className="draft-list">
                                { d.drafts.map((f, fkey) => {
                                  if( f.version == 1 ){
                                    return <li key={fkey}><a href={'/draft/'+ f.unique_id} target="_blank">初稿URL</a></li>
                                  } else {
                                    return <li key={fkey}><a href={'/draft/'+ f.unique_id} target="_blank">修正稿 ({f.version})</a></li>
                                  }
                                })}
                              </ul>
                            </div>
                          );
                        } catch(e) {
                          return <div className={'projects-score '+ c.id} key={key}></div>
                        }
                      }
                      
                      if( c.fmt == 'full_name' ){
                        return (
                          <div className={'projects-score '+ c.id} key={key}>
                            <img src={d.thumbnail} />{val}
                          </div>
                        );
                      }
                      
                      return (
                        <div className={'projects-score '+ c.id} key={key}>
                          {val}
                        </div>
                      );
                    })}
                  </div>
                </li>
              );
            })}
            
          </ul>
        </div>
        
        <ModalAction data={data} modal={this.state.modal} columns={editColumns} close_ev={this.toggleModal.bind(this)} />
      </div>
    );
  }
}
// -------------------------------------------------------

class ModalAction extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
    
    this.update = {};
    this.edit = {};
    this.view = {};
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    let columns = this.props.columns;
    
    this.state = {
      columns: columns,
      loading: false,
    };
  }
  // -------------------------------------------------------
  
  add_ev(sort) {
    let columns = this.state.columns;
    columns.push({ id: 'option_'+ Utils.getUniqueID(), is_original: true });
    
    //console.log('option_'+ Utils.getUniqueID());
    
    this.setState({ columns: [] });
    setTimeout( function(){ this.setState({ columns: columns }); }.bind(this), 50);
  }
  // -------------------------------------------------------
  
  change_ev(sort) {
    let columns = this.state.columns;
    
    columns = columns.map((d) => {
      try { if( this.update[d.id] != undefined ) d.name = this.update[d.id].value; } catch(e) {}
      try { if( this.edit[d.id] != undefined ) d.edit = this.edit[d.id].value; } catch(e) {}
      try { if( this.view[d.id] != undefined ) d.view = this.view[d.id].value; } catch(e) {}
      
      return d;
    });
    
    this.setState({ columns: columns });
  }
  // -------------------------------------------------------
  
  sort_ev(sort) {
    let columns = this.state.columns;
    columns = columns.map((d) => {
      d.order_no = 99;
      if( sort.indexOf(d.id) >= 0 ) d.order_no = sort.indexOf(d.id);
      return d;
    });
    columns = Utils.sort(columns, 'order_no', 'asc');
    
    this.setState({ columns: [] });
    setTimeout( function(){ this.setState({ columns: columns }); }.bind(this), 50);
  }
  // -------------------------------------------------------
  
  delete_ev(id) {
    let chk = confirm('カラムを削除してもよろしいですか？');
    if( chk == false ) return;
    
    let columns = this.state.columns;
    columns = columns.filter((d) => { if( d.id != id ) return d; });
    
    this.setState({ columns: [] });
    setTimeout( function(){ this.setState({ columns: columns }); }.bind(this), 50);
  }
  // -------------------------------------------------------
  
  submit_ev(id) {
    let chk = confirm('カラムの変更内容を保存してもよろしいですか？');
    if( chk == false ) return;
    
    this.setState({ loading: true });
    let columns = this.state.columns;
    Utils.request.bind(this)('/api/project/workflow/update_casting_columns', { project_id: this.props.data.project.id, columns: columns },
      function(res){
        alert('更新しました！');
        location.reload();
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    //console.log(columns);
    
    return (
      <ContentsModal
        view      = {this.props.modal}
        width     = {'calc(100% - 200px)'}
        height    = {'calc(100% - 110px)'}
        close_ev  = {this.props.close_ev.bind(this, false)}
        html      = {
          <div className="column-setting-modal">
            <SubLoading flg={this.state.loading} />
            <h1>カラムの編集</h1>
            
            <Sortable options={{ group: 'shared', animation: 150 }} tag="div" className="dataBody" onChange={this.sort_ev.bind(this)}>
              { this.state.columns.map((d, key) => {
                return (
                  <div key={key} className="dataItem" data-id={d.id}>
                    <div>
                      <OverlayTrigger key={key} placement="top" delayShow={250} overlay={<Tooltip>並び替え</Tooltip>}>
                        <i className="material-icons">reorder</i>
                      </OverlayTrigger>
                    </div>
                    <div className="main">
                      {(d.is_original === true)
                        ? <input type="text" className="text" ref={(input) => { this.update[d.id] = input }} onChange={this.change_ev.bind(this)} placeholder={'カラム名'} defaultValue={d.name} />
                        : <p className="name">{d.name}</p>
                      }
                    </div>
                    <div className="sub">
                      <div className="selectbox">
                        <select ref={(input) => { this.view[d.id] = input }} onChange={this.change_ev.bind(this)} defaultValue={d.view} >
                          <option value="all">表示する</option>
                          <option value="my">AIQのみ表示</option>
                          <option value="hidden">表示しない</option>
                        </select>
                      </div>
                    </div>
                    <div className="sub">
                      {(d.is_original === true) &&
                        <div className="selectbox">
                          <select ref={(input) => { this.edit[d.id] = input }} onChange={this.change_ev.bind(this)} defaultValue={d.edit} >
                            <option value="my">AIQのみ編集可能</option>
                            <option value="all">共同で編集可能</option>
                          </select>
                        </div>
                      }
                    </div>
                    
                    <div>
                      {(d.is_original === true) &&
                        <OverlayTrigger key={key} placement="top" delayShow={250} overlay={<Tooltip>削除</Tooltip>}>
                          <i className="material-icons" onClick={this.delete_ev.bind(this, d.id)}>delete</i>
                        </OverlayTrigger>
                      }
                    </div>
                  </div>
                );
              })}
            </Sortable>
            
            <div className="button plus" onClick={this.add_ev.bind(this)}>カラムを追加</div>
            
            <div className="button submit" onClick={this.submit_ev.bind(this)}>カラムを保存</div>
          </div>
        }
      />
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default Calender;